import store from "@/store/";
import router from "@/router";
import config from "../const/config";

export default {
  methods: {
    //----------------------------
    // GET
    //----------------------------

    /**
     * PK指定による1件検索処理.
     * @param {*} method RequestMapping Value
     * @param {*} key1 検索対象のPK
     * @param {*} key2 検索対象のPK
     */
    getData(method, key1 = "", key2 = "") {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      return new Promise((resolve, reject) => {
        this.axios
          .get(url)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * PK指定による1件検索処理.
     * @param {*} method RequestMapping Value
     * @param {*} key1 検索対象のPK1
     * @param {*} key2 検索対象のPK2
     * @param {*} key3 検索対象のPK3
     * @param {*} key4 検索対象のPK4
     * @param {*} key5 検索対象のPK5
     */
    getDataMultiKey(method, key1 = "", key2 = "", key3 = "", key4 = "", key5 = "") {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      url += this.addUrl(url, key3);
      url += this.addUrl(url, key4);
      url += this.addUrl(url, key5);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .get(url)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    // SERACH
    //----------------------------
    /**
     * クエリパラメータ付きで1件検索.
     * @param {}} method RequestMapping Value
     * @param {*} key 更新対象PK
     * @param {*} json 登録内容JSONコンテナ
     */
    getWithParams(method, params) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .get(url, { params: params })
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 条件付き検索処理
     * @param {*} method RequestMapping Value
     * @param {*} paramList 検索条件リスト(Key-Value)
     */
    getDataList(method, paramList = {}) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, paramList)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    // POST
    //----------------------------
    /**
     * 新規登録処理
     * @param {*} method RequestMapping Value
     * @param {*} json 登録内容JSONコンテナ
     */
    postData(method, json) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 新規登録処理
     * @param {}} method RequestMapping Value
     * @param {*} key 更新対象PK
     * @param {*} json 登録内容JSONコンテナ
     */
    postDataWithKey(method, key1, json) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 新規登録処理
     * @param {}} method RequestMapping Value
     * @param {*} key1 更新対象PK
     * @param {*} key2 更新対象PK
     * @param {*} json 登録内容JSONコンテナ
     */
    postDataWithKey2(method, key1 = "", key2 = "", json) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 新規登録処理
     * @param {}} method RequestMapping Value
     * @param {*} query 更新対象PKクエリストリング
     * @param {*} data 登録内容JSONコンテナ
     */
    postDataWithQuery(method, query, data) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, data, { params: query })
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    // PUT
    //----------------------------
    /**
     * 更新登録処理
     * @param {*} method RequestMapping Value
     * @param {*} key 更新対象PK
     * @param {*} json 登録内容JSONコンテナ
     */
    putData(method, key1, json) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .put(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 更新登録処理
     * @param {*} method RequestMapping Value
     * @param {*} json 登録内容JSONコンテナ
     * @param {*} key1 更新対象PK1
     * @param {*} key2 更新対象PK2
     * @param {*} key3 更新対象PK3
     */
    putDataMultiKey(method, json, key1 = "", key2 = "", key3 = "") {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      url += this.addUrl(url, key3);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .put(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    //PATCH
    //----------------------------

    patchData(method, json, key1 = "", key2 = "", key3 = "", key4 = "") {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      url += this.addUrl(url, key3);
      url += this.addUrl(url, key4);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .patch(url, json)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    /**
     * 更新(PATCH)処理 With Params
     * @param {*} method RequestMapping Value
     * @param {*} key1 更新対象PK1
     * @param {*} params Parameters
     */
    patchDataParams(method, key1 = "", params) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .patch(url, params)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    // DELETE
    //----------------------------
    /***
     * 削除
     */
    deleteDataParams(method, json) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .delete(url, { data: json })
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 削除処理
     * @param {*} method RequestMapping Value
     * @param {*} key1 更新対象PK
     */
    deleteData(method, key1) {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .delete(url)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },
    /**
     * 削除処理
     * @param {*} method RequestMapping Value
     * @param {*} key1 更新対象PK1
     * @param {*} key2 更新対象PK2
     * @param {*} key3 更新対象PK3
     * @param {*} key4 更新対象PK4
     * @param {*} key5 更新対象PK5
     */
    deleteDataMultiKey(method, key1 = "", key2 = "", key3 = "", key4 = "", key5 = "") {
      this.$store.commit("setIsLoading", true);
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      url += this.addUrl(url, key3);
      url += this.addUrl(url, key4);
      url += this.addUrl(url, key5);
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .delete(url)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          })
          .finally(() => {
            this.$store.commit("setIsLoading", false);
          });
      });
    },

    //----------------------------
    // 共通
    //----------------------------
    //
    addUrl(url, key) {
      if (key == null || key == "") {
        return "";
      }
      let str = "" + key;
      if (url.endsWith("/")) {
        if (str.startsWith("/")) {
          if (str.length == 1) {
            return "";
          } else {
            return str.substring(1) + "";
          }
        } else {
          return str + "";
        }
      } else {
        if (str.startsWith("/")) {
          return str + "";
        } else {
          return "/" + str + "";
        }
      }
    },
    /***
     * API通信成功時の共通処理
     */
    connServerSuccessHandler(){
      store.dispatch(config.STORE.INDEX.ACTION.serverErrorModalHide);
      store.dispatch(config.STORE.INDEX.ACTION.authErrorModalHide);
      return true;
    },
    /**
     * API通信時にエラーが返却された場合の共通処理
     * @param {*} err
     */
    connServerErrorHander(err) {
      let isLogin = store.getters.getIsLogin;

      if (err && err.response) {
        if(err.response.status == 403){
          //------------403 閲覧権限が無い------------
          if (isLogin) {
            // ログイン済だった場合は、ログイン画面へ遷移することを知らせるモーダルを表示.
            // App.Vueにモーダルの実装がある.
            store.dispatch(config.STORE.INDEX.ACTION.authErrorModalShow);
          }
          store.commit(config.STORE.USER_INFO.MUTATIONS.logOut);
          if(this.$route.path.indexOf("/manager") > -1){
            router.push(config.PAGES.MANAGER_LOGIN);
          }
          else{
            router.push(config.PAGES.LOGIN);
          }
        }else if(err.response.status >= 500){
          //------------ 500 ------------
          store.dispatch(config.STORE.INDEX.ACTION.serverErrorModalShow);
        }else{
          //その他
          this.showToastError(err);
        }
        return false;
      } else {
        return true;
      }
    },

    //----------------------------
    // file関連
    //----------------------------
    uploadFilePost(method, key1 = null, param) {
      let url = method;
      url += this.addUrl(url, key1);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, param, config)
          .then((response) => {
            this.connServerSuccessHandler();
            resolve(response.data);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          });
      });
    },
    /**
     * ファイルダウンロード
     * @param {*} method
     * @param {*} key1
     * @returns
     */
    downloadFileGetByKey(method, key1 = "", key2 = "") {
      let url = method;
      url += this.addUrl(url, key1);
      url += this.addUrl(url, key2);
      return new Promise((resolve, reject) => {
        this.axios
          .get(url, { responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            //レスポンスヘッダからファイル名を取得します
            const contentDisposition = response.headers["content-disposition"];
            const fileName = this.getFileName(contentDisposition);

            //ダウンロードします
            this.saveAs(blob, fileName);
            this.connServerSuccessHandler();
            resolve(response);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          });
      });
    },
    /**
     * ファイルダウンロード
     * @param {*} method
     * @param {*} query
     * @param {*} body
     * @returns
     */
    downloadFilePost(method, query = null, body = null) {
      let url = method;
      this.setCsrfHeader();
      return new Promise((resolve, reject) => {
        this.axios
          .post(url, body, { params: query, responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            //レスポンスヘッダからファイル名を取得します
            const contentDisposition = response.headers["content-disposition"];
            const fileName = this.getFileName(contentDisposition);

            //ダウンロードします
            this.saveAs(blob, fileName);

            this.connServerSuccessHandler();
            resolve(response);
          })
          .catch((err) => {
            this.connServerErrorHander(err);
            reject(err);
          });
      });
    },
    //
    saveAs(blob, fileName) {
      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    //
    getFileName(contentDisposition) {
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length);
      //デコードするとスペースが"+"になるのでスペースへ置換します
      fileName = decodeURI(fileName).replace(/\+/g, " ");
      return fileName;
    },
    //
    setCsrfHeader() {
      const csrf = this.$cookies.get("_ctkn");
      if (csrf) {
        this.axios.defaults.headers.common["X-CSRF-TOKEN"] = csrf;
      }
    },
  },
};
